const LiquifyHelper = {
    /**
     * Format a monetary value with the currency-format set in Shopify backend.
     *
     * @int value
     * @bool minor Optional, defaults to true.
     * @string shopMoneyFormat Shop-Setting, via Liquid: shop.money_with_currency_format
     */
    moneyFormat: (value, isMinor = true, shopMoneyFormat = '') => {
        let floatValue = parseFloat(value);

        if (isNaN(floatValue)) {
            return '';
        }

        floatValue = isMinor
            ? floatValue / 100
            : floatValue;

        let formattedValue = '';
        const match = shopMoneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
        const formatType = match ? match[1] : null;

        switch (formatType) {
            case 'amount':
                formattedValue = floatValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                break;
            case 'amount_no_decimals':
                formattedValue = Math.round(floatValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                break;
            case 'amount_with_comma_separator':
                formattedValue = floatValue.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                break;
            default:
                console.log('Error in moneyFormat. Unknown format type or none provided: ' + formatType);

                const formatter = new Intl.NumberFormat(Shopify.locale + '-' + Shopify.country, {
                    style: 'currency',
                    currency: Shopify.currency.active,
                });

                value = isMinor ? value / 100 : value;

                return formatter.format(value);
        }

        return shopMoneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, formattedValue);
    },

    htmlspecialchars_decode(string) {
        let tempElement = document.createElement('textarea');
        tempElement.innerHTML = string;
        return tempElement.value;
    },

    triggerClick: function (el) {
        if(!(el instanceof HTMLElement)) {
            console.info(el + ' must be an instance of HTMLElement')
            return
        }
        const ev = new KeyboardEvent("keydown",{
            code: 'Enter',
            key: 'Enter',
            charCode: 13,
            keyCode: 13,
            view: window,
            bubbles: true
        });

        el.dispatchEvent(ev);
    },

    /**
     * Trigger dropdown click to open minicart
     */
    handleTriggerClick: function () {
        let elements = document.querySelectorAll('[li-element="mini-cart-toggle"]');
        elements.forEach(element => {
            let closestDropdown = element.closest('.nav_shop-icon');
            if (closestDropdown) {
                this.triggerClick(closestDropdown);
            } else {
                console.error('(helper.js) No dropdown found for minicart trigger');
            }
        });
    },

    triggerClickById: (id) => {
        const el = document.getElementById(id)
        LiquifyHelper.triggerClick(el)
    },

    triggerClickByClass: (className) => {
        const elList = document.getElementsByClassName(className)
        for (const el of elList) {
            LiquifyHelper.triggerClick(el)
        }
    },

    serializeFormToObject: (form) => {
        const obj = {};
        try {
            const formData = new FormData(form);
            const properties = {};
            for (const [key, value] of formData) {
                if(key.indexOf('properties') !== -1) {
                    const name = key.replace('properties[', '').replace(']', '');
                    properties[name] = value;
                    obj["properties"] = properties;
                } else {
                    obj[key] = value;
                }
            }
        } catch(e) {
            console.info("form not found", form)
        }
        return obj ;
    },
};


/* Studio Grade: global product-card controller */
if (!window.AWProductCard) {
    window.AWProductCard = function () {
      return {
        // Core state
        product: null,
        options_by_name: null,
        selected_or_first_available_variant: null,
        productUrl: '',
        addToCartButton: true,

        // Availability maps (optional UI dim/disable)
        firstOptionHasAvailableChildren: {},
        secondOptionHasAvailableChildren: {},

        // ---- option helpers ----
        normalizeOptionKey(name) {
          if (!name) return null;
          if (this.options_by_name && this.options_by_name[name]) return name;
          const keys = Object.keys(this.options_by_name || {});
          const found = keys.find((k) => String(k).toLowerCase() === String(name).toLowerCase());
          return found || name;
        },

        getOptionValues(name) {
          const k = this.normalizeOptionKey(name);
          return this.options_by_name?.[k]?.option?.values || [];
        },

        isSwatchOption(optionName) {
          const n = String(optionName || '').toLowerCase();
          return n === 'scent' || n === 'color' || n === 'colour';
        },

        getOptionIndex(optionName) {
          const options = this.product?.options || [];
          return options.findIndex(
            (name) => String(name).toLowerCase() === String(optionName || '').toLowerCase()
          );
        },

        getCurrentSelections() {
          const options = this.product?.options || [];
          const currentVariant =
            this.selected_or_first_available_variant ||
            this.product?.selected_or_first_available_variant ||
            this.product?.initial_selected_or_first_available_variant;

          return options.map((name, index) => {
            return (
              currentVariant?.options?.[index] ??
              currentVariant?.[`option${index + 1}`] ??
              null
            );
          });
        },

        isOptionValueAvailable(optionName, optionValue) {
          const variants = this.product?.variants || [];
          const options = this.product?.options || [];
          const index = this.getOptionIndex(optionName);
          if (index < 0 || !variants.length) return true;

          // Visual options are primary selectors. Keep a colour/scent selectable
          // whenever it exists in at least one available variant, even if the
          // currently selected length needs to change with it.
          if (this.isSwatchOption(optionName)) {
            return variants.some(
              (variant) =>
                variant?.available &&
                String(variant[`option${index + 1}`]) === String(optionValue)
            );
          }

          const selections = this.getCurrentSelections();

          return variants.some((variant) => {
            if (!variant?.available) return false;
            if (String(variant[`option${index + 1}`]) !== String(optionValue)) return false;

            return options.every((otherName, otherIndex) => {
              if (otherIndex === index) return true;
              const selectedValue = selections[otherIndex];
              if (!selectedValue) return true;
              return String(variant[`option${otherIndex + 1}`]) === String(selectedValue);
            });
          });
        },

        // Prefer global implementation (image swatches + gradients)
        getSwatchStyle(label) {
          if (typeof window.getSwatchStyle === 'function') return window.getSwatchStyle(label);

          const key = String(label || '')
            .trim()
            .toLowerCase();
          const c = window.scentColors && window.scentColors[key] ? window.scentColors[key] : '';
          return c ? `background-color:${c};` : 'background-color:transparent;';
        },

        rebuildAvailabilityMaps() {
          const variants = this.product?.variants || [];
          const options = this.product?.options || [];
          const ob = this.product?.options_by_name || this.options_by_name || {};

          // option1 map
          this.firstOptionHasAvailableChildren = {};
          variants.forEach((v) => {
            const k = v.option1;
            if (!k) return;
            if (this.firstOptionHasAvailableChildren[k] == null) this.firstOptionHasAvailableChildren[k] = 0;
            this.firstOptionHasAvailableChildren[k] += v.available ? 1 : 0;
          });

          // option2 map constrained by selected option1
          this.secondOptionHasAvailableChildren = {};
          if (options.length > 1) {
            const selected1 = this.product?.selected_or_first_available_variant?.option1;
            const option2Name = options[1];
            const values2 = ob?.[option2Name]?.option?.values || [];
            values2.forEach((v2) => {
              this.secondOptionHasAvailableChildren[v2] = variants.some(
                (v) => v.available && v.option1 === selected1 && v.option2 === v2
              );
            });
          }
        },

        isSwatchSelected(variantName) {
          const opt = (this.product?.options || []).find((o) => this.isSwatchOption(o));
          if (!opt) return false;
          const idx = (this.product.options || []).findIndex((o) => o === opt);
          const opts = this.selected_or_first_available_variant?.options || [];
          return (idx > -1 && opts[idx] === variantName) || opts.includes(variantName);
        },

        applyOption(optionName, optionValue) {
          if (!this.product || !Array.isArray(this.product.variants) || !this.product.variants.length) return;

          const options = this.product.options || [];
          const variants = this.product.variants || [];
          const changedIndex = this.getOptionIndex(optionName);
          if (changedIndex < 0) return;

          const current = this.getCurrentSelections();
          current[changedIndex] = optionValue;

          const matchesAll = (variant) =>
            options.every((_, index) => {
              const selectedValue = current[index];
              return !selectedValue || String(variant[`option${index + 1}`]) === String(selectedValue);
            });

          // 1. Exact currently requested combination.
          let chosen = variants.find((variant) => variant?.available && matchesAll(variant));

          // 2. If that combination does not exist, preserve the option the shopper
          //    just chose and select the available variant that matches the greatest
          //    number of their other current choices.
          if (!chosen) {
            const candidates = variants.filter(
              (variant) =>
                variant?.available &&
                String(variant[`option${changedIndex + 1}`]) === String(optionValue)
            );

            let bestScore = -1;
            candidates.forEach((variant) => {
              let score = 0;
              options.forEach((_, index) => {
                if (index === changedIndex || !current[index]) return;
                if (String(variant[`option${index + 1}`]) === String(current[index])) score += 1;
              });
              if (score > bestScore) {
                bestScore = score;
                chosen = variant;
              }
            });
          }

          // 3. Sold-out fallback only when there is no available variant carrying
          //    the chosen value at all.
          if (!chosen) {
            chosen =
              variants.find(
                (variant) => String(variant[`option${changedIndex + 1}`]) === String(optionValue) && matchesAll(variant)
              ) ||
              variants.find(
                (variant) => String(variant[`option${changedIndex + 1}`]) === String(optionValue)
              ) ||
              variants.find((variant) => variant?.available) ||
              variants[0];
          }

          if (!chosen) return;

          const featured = chosen.featured_image?.src || chosen.featured_image;

          this.product.selected_or_first_available_variant = {
            ...(this.product.selected_or_first_available_variant || {}),
            ...chosen,
            featured_image: featured,
          };

          this.selected_or_first_available_variant = this.product.selected_or_first_available_variant;
          this.addToCartButton = !!chosen.available;

          this.rebuildAvailabilityMaps();

          try {
            window.dispatchEvent(
              new CustomEvent('aw-card-variant-changed', {
                detail: { productId: this.product?.id, variant: this.product.selected_or_first_available_variant },
              })
            );
          } catch (_) {}
        },

        selectOption(optionName, optionValue) {
          this.applyOption(optionName, optionValue);
        },

        // compatibility
        setVariant(e) {
          if (e && e.target && e.target.name) {
            this.applyOption(e.target.name, e.target.value);
          }
        },

        /* ------------------------------------------------------------
           Add to cart
           - Do NOT leave this as a no-op.
           - Delegates to handleVariant if present (so you keep one source of truth),
             but also includes a hard fallback that will still work.
           ------------------------------------------------------------ */
        async addToCart(e, toggleMiniCart = true) {
          if (e && typeof e.preventDefault === 'function') e.preventDefault();

          // Prefer liquify_custom.js implementation if available, but resolve it at click time
          if (typeof window.handleVariant === 'function') {
            try {
              const hv = window.handleVariant(
                this.product,
                this.options_by_name,
                this.selected_or_first_available_variant,
                window.scentColors || {}
              );

              if (hv && typeof hv.addToCart === 'function') {
                return hv.addToCart.call(this, e, toggleMiniCart);
              }
            } catch (err) {
              console.error('handleVariant addToCart delegation failed', err);
            }
          }

          // Hard fallback: direct Shopify AJAX add
          const vId =
            this.selected_or_first_available_variant?.id ||
            this.product?.selected_or_first_available_variant?.id ||
            this.product?.variants?.[0]?.id;

          if (!vId) return;

          const root =
            window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

          try {
            const res = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: vId, quantity: 1 }] }),
            });

            const added = await res.json().catch(() => null);

            if (!res.ok || (added && added.status && Number(added.status) >= 400)) {
              const msg = added?.message || 'Add to cart failed';
              const desc = added?.description || '';
              try {
                this.$dispatch('showcartmessage', { status: 'error', message: msg, description: desc });
              } catch (_) {}
              return;
            }

            // Fetch full cart to keep UI consistent
            let cart = null;
            try {
              const cartRes = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
              cart = await cartRes.json();
            } catch (_) {}

            try {
              this.$dispatch('cartupdated', cart || added);
            } catch (_) {}
            if (toggleMiniCart) {
              try {
                this.$dispatch('toggleminicart');
              } catch (_) {}
            }

            try {
              window.dispatchEvent(new CustomEvent('aw-cart-updated', { detail: { cart, added } }));
            } catch (_) {}
            if (toggleMiniCart) {
              try {
                window.dispatchEvent(new CustomEvent('aw-open-cart'));
              } catch (_) {}
            }
          } catch (err) {
            console.error('Add to cart failed', err);
            try {
              this.$dispatch('showcartmessage', {
                status: 'error',
                message: 'Add to cart failed',
                description: err?.message || '',
              });
            } catch (_) {}
          }
        },

        // compatibility
        activateVariants() {},

        init() {
          try {
            const el = this.$el;

            const p = JSON.parse(el.dataset.product || 'null');
            const ob = JSON.parse(el.dataset.optionsByName || 'null');
            const v = JSON.parse(el.dataset.selectedVariant || 'null');
            const u = el.dataset.productUrl || (p && p.url) || '';

            // Stamp bundle flag — used by add to cart intercept and modal
            if (p) p.isBundle = el.dataset.isBundle === 'true';

            // Merge in handleVariant methods IF available,
            // but do not allow it to override local option switching/swatch helpers.
            const hv =
              typeof window.handleVariant === 'function'
                ? window.handleVariant(p, ob, v, window.scentColors || {})
                : {};

            const protectedKeys = new Set([
              'init',
              'applyOption',
              'selectOption',
              'setVariant',
              'normalizeOptionKey',
              'getOptionValues',
              'isSwatchOption',
              'getSwatchStyle',
              'rebuildAvailabilityMaps',
              // Keep our delegating addToCart to prevent "no-op" if hv loads late
              'addToCart',
            ]);

            for (const k in hv) {
              if (!protectedKeys.has(k)) this[k] = hv[k];
            }

            this.product = p;
            this.options_by_name = ob;
            this.productUrl = u;

            if (this.product) {
              this.product.options_by_name = ob;

              this.product.initial_selected_or_first_available_variant =
                this.product.initial_selected_or_first_available_variant ||
                v ||
                this.product.selected_or_first_available_variant ||
                (this.product.variants && this.product.variants[0]) ||
                null;

              this.product.selected_or_first_available_variant =
                v ||
                this.product.selected_or_first_available_variant ||
                this.product.initial_selected_or_first_available_variant ||
                (this.product.variants && this.product.variants[0]) ||
                null;
            }

            this.selected_or_first_available_variant = this.product?.selected_or_first_available_variant || null;

            // Listen for modal variant changes and sync THIS card
            this._onVariantChanged = (e) => {
              const d = e?.detail || {};
              if (!d.variant) return;
              if (String(d.productId) !== String(this.product?.id)) return;

              this.product.selected_or_first_available_variant = {
                ...(this.product.selected_or_first_available_variant || {}),
                ...d.variant,
              };

              this.selected_or_first_available_variant = this.product.selected_or_first_available_variant;
              this.addToCartButton = true;
              this.rebuildAvailabilityMaps();
            };

            window.addEventListener('aw-variant-changed', this._onVariantChanged);

            this.rebuildAvailabilityMaps();

            this.$nextTick(() => {
              if (typeof this.activateVariants === 'function') this.activateVariants();
            });
          } catch (err) {
            console.error('AWProductCard init failed', err);
          }
        },

        // Optional cleanup if you ever remove cards dynamically
        destroy() {
          try {
            if (this._onVariantChanged) {
              window.removeEventListener('aw-variant-changed', this._onVariantChanged);
            }
          } catch (_) {}
        },
      };
    };
  }

// Force "$22.00 CAD" (2 decimals, dot separator, currency code)
  window.formatMoneyWithCode = function formatMoneyWithCode(cents, currencyCode) {
    const code = currencyCode || window.Shopify?.currency?.active || 'CAD';

    // Shopify variant prices are usually integers in cents
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';

    const amount = (n / 100).toFixed(2);

    const symbols = {
      CAD: '$',
      USD: '$',
      AUD: '$',
      NZD: '$',
      SGD: '$',
      EUR: '€',
      GBP: '£',
      CHF: 'CHF ',
      SEK: 'kr ',
      NOK: 'kr ',
      DKK: 'kr ',
      JPY: '¥',
      CNY: '¥',
      HKD: '$',
      INR: '₹',
    };

    const symbol = symbols[code] ?? '';
    return `${symbol}${amount} ${code}`.trim();
  };
